import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 1H8V5H16V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 3H3V23H12.8762C12.0139 21.897 11.5 20.5085 11.5 19C11.5 15.4102 14.4101 12.5 18 12.5C19.0821 12.5 20.1025 12.7644 21 13.2322V3H18V7H6V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.3438 19.4143L13.758 18.0001L16.5864 20.8285L22.2432 15.1716L23.6575 16.5858L16.5864 23.6569L12.3438 19.4143Z"}}]};

const TaskCheckedFilled = Vue.extend<IconProps>({
  name: 'TaskCheckedFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'task-checked-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TaskCheckedFilled;
